// Error Metrics
export const REGISTER_LEARNING_ACTIVITY_ERROR = 'RegisterLearningActivity_Error';
export const WITHDRAW_LEARNING_ACTIVITY_ERROR = 'WithdrawLearningActivity_Error';
export const WAITLIST_LEARNING_ACTIVITY_ERROR = 'WaitlistLearningActivity_Error';
export const UNWAITLIST_LEARNING_ACTIVITY_ERROR = 'UnwaitlistLearningActivity_Error';
export const REQUEST_SELF_ORG_JOIN_ERROR = 'RequestSelfOrgJoin_Error';
export const PAGINATED_LEARNING_ACTIVITIES_ERROR = 'PaginatedLearningActivities_Error';
export const PAGINATED_LEARNING_ACTIVITIES_SUCCESS = 'PaginatedLearningActivities_Success';
export const LEARNING_ACTIVITY_ERROR = 'LearningActivity_Error';
export const LEARNING_ACTIVITYWITHOUTRREGISTRATIONCOUNTER_ERROR = 'LearningActivityWithoutRegistrationCounter_Error';
export const LEARNER_RECORDS_ERROR = 'LearnerRecords_Error';
export const LEARNING_GOAL_TRANSCRIPTS_ERROR = 'LearningGoalTranscripts_Error';
export const SAVE_ILT_EVALUTION_RESPONSE_ERROR = 'SaveIltEvaluationResponse_Error';
export const CERTIFICATE_BY_TRANSCRIPT_ID_ERROR = 'CertificateByTranscriptId_Error';
export const CATALOG_ITEM_NOT_FOUND_ERROR = 'CatlogItemNotFound_Error';
export const INVALID_COURSE_DETAILS_ERROR = 'InvalidCourseDetails_Error';
